import type { IPredictionOutcomeEvent, IPredictionOutcomeEventSeriesRecord, Security } from '@talos/kyoko';

import { getPredictionCategoryTab } from './predictionCardSeries';

export type MarketOption = {
  name: string;
  label: string;
};

/**
 * Shared label / description / category-tab / favourite-symbol accessors for the prediction
 * Market → Series → Event → Outcome selectors. Defined at module scope so `useAutocomplete`
 * memos key off stable identities (inline lambdas would rebuild/re-sort the option lists on
 * every parent re-render). Reused by the market card form and the OMS order/RFQ selector.
 */
export const getMarketLabel = (option: MarketOption) => option.label;
export const getSeriesLabel = (series: IPredictionOutcomeEventSeriesRecord) => series.SeriesName;
export const getSeriesDescription = (series: IPredictionOutcomeEventSeriesRecord) => series.SeriesSymbol;
export const getSeriesTabGroup = (series: IPredictionOutcomeEventSeriesRecord) =>
  getPredictionCategoryTab(series.Category);
export const getEventLabel = (event: IPredictionOutcomeEvent) => event.EventName;
export const getEventDescription = (event: IPredictionOutcomeEvent) => event.EventSymbol;
export const getEventTabGroup = (event: IPredictionOutcomeEvent) => getPredictionCategoryTab(event.Category);
export const getOutcomeLabel = (outcome: Security) => outcome.DisplaySymbol ?? outcome.Symbol;
export const getOutcomeDescription = (outcome: Security) => outcome.Description;
export const getSeriesFavoriteSymbol = (series: IPredictionOutcomeEventSeriesRecord) => series.SeriesSymbol;
export const getEventFavoriteSymbol = (event: IPredictionOutcomeEvent) => event.EventSymbol;
export const getOutcomeFavoriteSymbol = (outcome: Security) => outcome.Symbol;
